webpackJsonp([35783957827783],{

/***/ 10:
/***/ (function(module, exports) {

	'use strict';
	
	var removeHash = function removeHash(hex) {
	  return hex.charAt(0) === '#' ? hex.slice(1) : hex;
	};
	
	var parseHex = function parseHex(nakedHex) {
	  var isShort = 3 === nakedHex.length || 4 === nakedHex.length;
	
	  var twoDigitHexR = isShort ? '' + nakedHex.slice(0, 1) + nakedHex.slice(0, 1) : nakedHex.slice(0, 2);
	  var twoDigitHexG = isShort ? '' + nakedHex.slice(1, 2) + nakedHex.slice(1, 2) : nakedHex.slice(2, 4);
	  var twoDigitHexB = isShort ? '' + nakedHex.slice(2, 3) + nakedHex.slice(2, 3) : nakedHex.slice(4, 6);
	  var twoDigitHexA = (isShort ? '' + nakedHex.slice(3, 4) + nakedHex.slice(3, 4) : nakedHex.slice(6, 8)) || 'ff';
	
	  // const numericA = +((parseInt(a, 16) / 255).toFixed(2));
	
	  return {
	    r: twoDigitHexR,
	    g: twoDigitHexG,
	    b: twoDigitHexB,
	    a: twoDigitHexA
	  };
	};
	
	var hexToDecimal = function hexToDecimal(hex) {
	  return parseInt(hex, 16);
	};
	
	var hexesToDecimals = function hexesToDecimals(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b,
	      a = _ref.a;
	  return {
	    r: hexToDecimal(r),
	    g: hexToDecimal(g),
	    b: hexToDecimal(b),
	    a: +(hexToDecimal(a) / 255).toFixed(2)
	  };
	};
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var formatRgb = function formatRgb(decimalObject, parameterA) {
	  var r = decimalObject.r,
	      g = decimalObject.g,
	      b = decimalObject.b,
	      parsedA = decimalObject.a;
	
	  var a = isNumeric(parameterA) ? parameterA : parsedA;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	};
	
	/**
	 * Turns an old-fashioned css hex color value into a rgb color value.
	 *
	 * If you specify an alpha value, you'll get a rgba() value instead.
	 *
	 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
	 * @param An alpha value to apply. (optional) ('0.5', '0.25')
	 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
	 */
	var hexToRgba = function hexToRgba(hex, a) {
	  var hashlessHex = removeHash(hex);
	  var hexObject = parseHex(hashlessHex);
	  var decimalObject = hexesToDecimals(hexObject);
	
	  return formatRgb(decimalObject, a);
	};
	
	module.exports = hexToRgba;

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _postData = __webpack_require__(79);
	
	Object.keys(_postData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _postData[key];
	    }
	  });
	});

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.worksData = exports.mockPostData = undefined;
	
	var _routes = __webpack_require__(16);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mockPostData = exports.mockPostData = [{
	  id: 1,
	  title: 'Empathy',
	  initialPostDate: 'April 2018',
	  url: _routes2.default.posts.empathy
	}, {
	  id: 2,
	  title: "An New Take on iOS' Now Playing",
	  initialPostDate: 'April 2018',
	  url: '/writing/a-new-take-on-ios-now-playing'
	}];
	
	var worksData = exports.worksData = [{
	  id: 1,
	  title: 'Erb Connect',
	  initialPostDate: 'April 2018',
	  url: _routes2.default.erbConnect,
	  published: false
	}, {
	  id: 2,
	  title: 'Maven Pro',
	  initialPostDate: 'January 2017',
	  url: _routes2.default.mavenPro,
	  published: true
	}];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _feed = __webpack_require__(41);
	
	var _typography = __webpack_require__(12);
	
	var _api = __webpack_require__(78);
	
	var _routes = __webpack_require__(16);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  var allMarkdownRemark = data.allMarkdownRemark;
	  var edges = allMarkdownRemark.edges;
	
	  var Posts = edges.filter(function (edge) {
	    return !!edge.node.frontmatter.date;
	  }).map(function (edge) {
	    return _react2.default.createElement(_feed.PostLink, {
	      key: edge.node.id,
	      to: edge.node.frontmatter.path,
	      title: edge.node.frontmatter.title,
	      date: edge.node.frontmatter.date
	    });
	  });
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _feed.PostGroup,
	      null,
	      _react2.default.createElement(
	        _feed.PostTitle,
	        null,
	        _react2.default.createElement(
	          _typography.UnstyledLink,
	          { to: _routes2.default.writing },
	          'Writing'
	        )
	      ),
	      _react2.default.createElement(
	        _typography.UnstyledList,
	        null,
	        Posts
	      )
	    ),
	    _react2.default.createElement(
	      _feed.PostGroup,
	      null,
	      _react2.default.createElement(
	        _feed.PostTitle,
	        null,
	        _react2.default.createElement(
	          _typography.UnstyledLink,
	          { to: _routes2.default.works },
	          'Works'
	        )
	      ),
	      _react2.default.createElement(
	        _typography.UnstyledList,
	        null,
	        _api.worksData.map(function (item) {
	          return item.published && _react2.default.createElement(_feed.PostLink, {
	            key: item.id,
	            title: item.title,
	            date: item.initialPostDate,
	            to: item.url
	          });
	        })
	      )
	    )
	  );
	};
	exports.default = IndexPage;
	
	// $FlowFixMe
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    fill: ', ';\n  '], ['\n    fill: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } // TODO: Add left arrow SVG
	
	
	var color = _styles.myTheme.color;
	
	var arrowTheme = (0, _styledTheming2.default)('mode', {
	  light: color.lightBlueGray,
	  dark: color.lightBlueGray
	});
	
	var ArrowSVG = function ArrowSVG(_ref) {
	  var fill = _ref.fill;
	
	  var IconGroup = _styledComponents2.default.g(_templateObject, fill || arrowTheme);
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: '6',
	      height: '10'
	    },
	    _react2.default.createElement(
	      'g',
	      {
	        fill: 'none',
	        fillRule: 'evenodd'
	      },
	      _react2.default.createElement(
	        IconGroup,
	        { transform: 'translate(-310 -15)' },
	        _react2.default.createElement('path', {
	          d: 'M315.655 19.951l.002.002-4.95 4.95-.707-.707 4.244-4.245L310 15.707l.707-.707 4.95 4.95z'
	        })
	      )
	    )
	  );
	};
	ArrowSVG.defaultProps = {
	  fill: arrowTheme
	};
	
	var Arrow = function Arrow(_ref2) {
	  var position = _ref2.position;
	  return _react2.default.createElement(
	    'div',
	    { className: 'p2' },
	    position === 'left' ? '👈' : _react2.default.createElement(ArrowSVG, null)
	  );
	};
	Arrow.defaultProps = {
	  position: 'right'
	};
	
	exports.default = Arrow;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PostGroup = exports.PostTitle = exports.PostLink = exports.Arrow = undefined;
	
	var _arrow = __webpack_require__(17);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _postLink = __webpack_require__(44);
	
	var _postLink2 = _interopRequireDefault(_postLink);
	
	var _postTitle = __webpack_require__(46);
	
	var _postTitle2 = _interopRequireDefault(_postTitle);
	
	var _postGroup = __webpack_require__(42);
	
	var _postGroup2 = _interopRequireDefault(_postGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Arrow = _arrow2.default;
	exports.PostLink = _postLink2.default;
	exports.PostTitle = _postTitle2.default;
	exports.PostGroup = _postGroup2.default;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _postGroup = __webpack_require__(43);
	
	var _postGroup2 = _interopRequireDefault(_postGroup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _postGroup2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  base: 'pt2 pb2'
	};
	
	var PostGroup = function PostGroup(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'section',
	    { className: (0, _classnames2.default)(style.base, className) },
	    children
	  );
	};
	PostGroup.defaultProps = {
	  className: ''
	};
	
	exports.default = PostGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _postLink = __webpack_require__(45);
	
	var _postLink2 = _interopRequireDefault(_postLink);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _postLink2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  margin-bottom: ', ';\n  line-height: 1.4;\n  font-size: 18px;\n  font-weight: 400;\n  letter-spacing: -0.45px;\n  color: ', ';\n'], ['\n  margin: 0;\n  margin-bottom: ', ';\n  line-height: 1.4;\n  font-size: 18px;\n  font-weight: 400;\n  letter-spacing: -0.45px;\n  color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  color: ', ';\n  font-size: 0.875rem;\n  letter-spacing: -0.15px;\n'], ['\n  margin: 0;\n  color: ', ';\n  font-size: 0.875rem;\n  letter-spacing: -0.15px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  color: ', ';\n  padding: ', ' 0;\n\n  @media screen and (min-width: ', ') {\n    background: transparent;\n    transition: background 100ms ease-in-out;\n    border-radius: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n    margin-left: -', ';\n    margin-right: -', ';\n    margin-bottom: ', ';\n\n    &:hover {\n      background: ', ';\n    }\n  }\n'], ['\n  text-decoration: none;\n  color: ', ';\n  padding: ', ' 0;\n\n  @media screen and (min-width: ', ') {\n    background: transparent;\n    transition: background 100ms ease-in-out;\n    border-radius: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n    margin-left: -', ';\n    margin-right: -', ';\n    margin-bottom: ', ';\n\n    &:hover {\n      background: ', ';\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-right: -', ';\n'], ['\n  margin-right: -', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _hexToRgba = __webpack_require__(10);
	
	var _hexToRgba2 = _interopRequireDefault(_hexToRgba);
	
	var _arrow = __webpack_require__(17);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var space = _styles.myTheme.space,
	    color = _styles.myTheme.color,
	    borderRadii = _styles.myTheme.borderRadii,
	    breakpoint = _styles.myTheme.breakpoint;
	
	
	var titleThemeColor = (0, _styledTheming2.default)('mode', {
	  dark: color.white,
	  light: color.darkBlueGray
	});
	var ListItem = _styledComponents2.default.li(_templateObject);
	var PostDetails = _styledComponents2.default.div(_templateObject);
	var PostTitle = _styledComponents2.default.h4(_templateObject2, space.one, titleThemeColor);
	var dateThemeColor = (0, _styledTheming2.default)('mode', {
	  dark: color.darkSilver,
	  light: color.silver
	});
	var PostDate = _styledComponents2.default.p(_templateObject3, dateThemeColor);
	var hoverStateBackground = (0, _styledTheming2.default)('mode', {
	  dark: (0, _hexToRgba2.default)(color.white, 0.03),
	  light: (0, _hexToRgba2.default)(color.black, 0.03)
	});
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, color.offWhite, space.one, breakpoint.small, borderRadii.two, space.one, space.one, space.one, space.one, space.half, hoverStateBackground);
	var ArrowContainer = _styledComponents2.default.div(_templateObject5, space.two);
	
	var PostItem = function PostItem(_ref) {
	  var title = _ref.title,
	      date = _ref.date,
	      to = _ref.to;
	  return _react2.default.createElement(
	    ListItem,
	    null,
	    _react2.default.createElement(
	      StyledLink,
	      {
	        to: to,
	        className: 'flex items-center'
	      },
	      _react2.default.createElement(
	        PostDetails,
	        null,
	        _react2.default.createElement(
	          PostTitle,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          PostDate,
	          null,
	          date
	        )
	      ),
	      _react2.default.createElement(
	        ArrowContainer,
	        { className: 'ml-auto' },
	        _react2.default.createElement(_arrow2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = PostItem;
	module.exports = exports['default'];

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _postTitle = __webpack_require__(47);
	
	var _postTitle2 = _interopRequireDefault(_postTitle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _postTitle2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-bottom: 0.0625rem solid ', ';\n  padding-bottom: ', ';\n  font-weight: ', ';\n  text-transform: uppercase;\n  font-size: ', ';\n  color: ', ';\n'], ['\n  border-bottom: 0.0625rem solid ', ';\n  padding-bottom: ', ';\n  font-weight: ', ';\n  text-transform: uppercase;\n  font-size: ', ';\n  color: ', ';\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _hexToRgba = __webpack_require__(10);
	
	var _hexToRgba2 = _interopRequireDefault(_hexToRgba);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var color = _styles.myTheme.color,
	    space = _styles.myTheme.space,
	    fontWeight = _styles.myTheme.fontWeight,
	    fontSize = _styles.myTheme.fontSize;
	
	
	var dividerColor = (0, _styledTheming2.default)('mode', {
	  light: (0, _hexToRgba2.default)(color.darkBlueGray, 0.1),
	  dark: (0, _hexToRgba2.default)(color.white, 0.1)
	});
	var postTitleColor = (0, _styledTheming2.default)('mode', {
	  light: color.silver,
	  dark: color.darkSilver
	});
	var PostTitle = _styledComponents2.default.h4(_templateObject, dividerColor, space.one, fontWeight.six, fontSize.eight, postTitleColor);
	
	exports.default = PostTitle;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0bff30abcd1fa86d2879.js